module.exports = "<div class=\"loading-overlay\">\n  <div class=\"loading-container\">\n    <div class=\"loading-icon\"></div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/loader/loader.component.html
// module id = ../../../../../src/app/shared/components/loader/loader.component.html
// module chunks = 12